import { NavLink, Navigate, Outlet } from "react-router-dom";
import { BadgeDollarSign, HelpCircle, Home, LogOut, Megaphone, Package, Settings, ShoppingBag, Star } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const links = [
  { to: "/admin", label: "Home", icon: Home, end: true },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/promocodes", label: "Promo Codes", icon: BadgeDollarSign },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
  { to: "/admin/settings", label: "Settings", icon: Settings },
  { to: "/admin/testimonials", label: "Testimonials", icon: Star },
  { to: "/admin/faqs", label: "FAQs", icon: HelpCircle },
];

export default function AdminLayout() {
  const auth = useAuth();
  if (!auth.admin) return <Navigate to="/admin/login" replace />;

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <div className="admin-brand">
          <Megaphone size={22} />
          <span>Moataz Admin</span>
        </div>
        <nav>
          {links.map((link) => {
            const Icon = link.icon;
            return (
              <NavLink key={link.to} to={link.to} end={link.end}>
                <Icon size={18} />
                {link.label}
              </NavLink>
            );
          })}
        </nav>
        <button type="button" onClick={auth.adminLogout}>
          <LogOut size={18} />
          Logout
        </button>
      </aside>
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
